'use client';
import { useTranslations } from 'next-intl';
import { OverflowGrid } from '@//components/OverflowGrid';
import type { FilterHistoryItem } from '@//data/filter-history/utils';
import StartpageLatestSearchesResult from './StartpageLatestSearchesResult';

interface MarketMetadata {
  pageLinks: {
    searchPage: string;
  };
}

interface StartpageLatestSearchSectionProps {
  search: FilterHistoryItem;
  marketMetadata: MarketMetadata;
  sectionIndex: number;
}

const StartpageLatestSearchSection = ({
  search,
  marketMetadata,
  sectionIndex,
}: StartpageLatestSearchSectionProps) => {
  const t = useTranslations('pages.startpage.latestSearches');

  return (
    <OverflowGrid
      id={`latest-search-${sectionIndex}`}
      columns={3}
      heading={t('heading')}
      link={{
        href: `${marketMetadata.pageLinks.searchPage}?${search.query}`,
        title: t('link.title', { searchName: search.label }),
        ariaLabel: t('link.title', { searchName: search.label }),
      }}
    >
      <StartpageLatestSearchesResult
        searchQuery={search.query}
        testIdPrefix={`latest-search-${sectionIndex}`}
      />
    </OverflowGrid>
  );
};

export default StartpageLatestSearchSection;
